{ Jadelet, Observable } from @danielx/dui

// A slot in the purchase prompt for the other things I make. Each time the
// prompt shows the slot moves to the next ad; the position persists so the
// rotation carries across visits. Nothing renders once purchased.
STORAGE_KEY := "ad-slot"

Template := Jadelet.exec """
  section.ad-slot(class=@hiddenIfPurchased)
    @ad
"""

// The Steam widget for the free demo: its button runs the demo when Steam is
// installed, otherwise it links to the store page.
NUTSHOT_DEMO_APP_ID := 5003740
NUTSHOT_WIDGET_TEXT := "Also by me: throw objects to hit people in the nuts. Play the free demo and wishlist the full game on Steam."

SteamWidgetTemplate := Jadelet.exec """
  iframe(src=@src frameborder="0" width="646" height="190")
"""

ChipTemplate := Jadelet.exec """
  a.chip(href="https://danielx.net/chip/?utm_source=paint-composer&utm_medium=app&utm_content=purchase-prompt" target="_blank" rel="noopener")
    img(src="https://danielx.net/chip/assets/logo/card.png" alt="Daily Chip" width="320" height="168")
    div
      h2 Daily Chip
      p One NES set for everyone, once a day: a key, a form, five rhythm × voice slots. Two squares, a triangle, noise; a real 2A03 in the browser.
      p.cta Play today's →
"""

ads := [
  ->
    SteamWidgetTemplate
      src: `https://store.steampowered.com/widget/${NUTSHOT_DEMO_APP_ID}/?t=${encodeURIComponent NUTSHOT_WIDGET_TEXT}`
  ->
    ChipTemplate {}
]

export AdSlot := (player: Player) ->
  index := Observable do
    try
      parseInt(localStorage.getItem(STORAGE_KEY)!, 10) or 0
    catch
      0

  self :=
    hiddenIfPurchased: player.hiddenIfPurchased
    ad: ->
      return "" if player.purchased()
      ads[index() % ads.length]()

    // called each time the purchase prompt shows
    rotate: ->
      index index() + 1
      try localStorage.setItem(STORAGE_KEY, String(index()))

    element: null

  self.element = Template self

  return self

export default AdSlot
